import default_parameters 	from "@/components/general_parameters/default_parameters.js" 
import EventBus 			from "@/event-bus"

class user_class {
	constructor(user){
		this.list_default_permissions = [];
		this.list_permissions_user 	= [];	
		this.list_default_resources = [];//[ ...default_parameters.modules ];
		this.list_default_modules   = [];
		this.list_resources 		= [];
		this.user 					= user;
		this.permission 			= {};
		this.render_modules();
		this.roles  				= [];
	}
	update_item(key, item){
		if (key && this[key]) {
			this[key] = item;
		}else{
			console.warn("Warn Error update item : ", key, item);
		}
	}

	get_item(key){
		if (key && this[key]) {
			return this[key];
		}
		return null
	}

	check_permissions(modul , action){		
		if (this.permission && this.permission[modul] && this.permission[modul][action]) {
			// action : can_add, can_view, can_edit , can_delete			
			return true;
		}else{
			return false
		}
	}

	render_modules(){
		let list 	= [...default_parameters.modules];
		let temp 	= [];
		let roleId 	= this.user &&  this.user.user && this.user.user.roleId ? this.user.user.roleId : null ;
		list.forEach((def, idx_def)=>{
			if (def.type_component) {
              	this.list_default_resources.push(def);
				this.add_list_permissions(def, roleId);				
				// console.log("ROUTE main ", def.module)
            }
			// if (def.enable) {
			// }
			if (def.assosiateds && def.assosiateds.length > 0) {
				def.assosiateds.forEach((aso, idx_aso)=>{
					// if (aso.enable) {

					if (aso && aso.type_component) {
						// console.log("ROUTE aso", aso.module)
						this.add_list_permissions(aso, roleId);
					// }
	 					this.list_default_resources.push(aso);
	                }
				})
			}
			if (def.sub_modules && def.sub_modules.length > 0) {
				def.sub_modules.forEach((sub, idx_sub)=>{
					// if (sub.enable) {
					if (sub && sub.type_component) {
						// console.log("ROUTE sub", sub.module)
						this.add_list_permissions(sub, roleId);
					// }
	                  // console.log("sub Adding 1", tmp1);
	                  this.list_default_resources.push(sub);
	                }
				})

			}
		});
		// console.log("CREATE permission DEFAULT ", this.list_default_permissions);

		// this.render_permissions_user();
		// console.log("LIST ------------------> ", this.list_permissions)

	}
	add_list_permissions(item, roleId){
		let name   		= item.module || item.sub_module;
		let access 		= roleId && item.roles && item.roles.includes(roleId)  ? true : false;;
		let can_add 	= access; 
		let can_view 	= access;
		let can_edit 	= access;
		let can_delete 	= false; // roleId == 1 ? true :
		let temp 		= {			
			name,
			can_add,
			can_view,
			can_edit,
			can_delete, 
			type : item.type_component,
			// resourceId : 1,
		};
		this.list_default_permissions.push(temp);
		// this.permission[temp.name] = temp;
	}
	render_permissions_user(){
		const getUpdatedAt = (item) => {
			if (!item || !item.updatedAt) return 0;
			const parsed = new Date(item.updatedAt).getTime();
			return Number.isNaN(parsed) ? 0 : parsed;
		};

		const shouldReplacePermission = (nextPermission, currentPermission) => {
			if (!currentPermission) return true;
			const nextUpdatedAt = getUpdatedAt(nextPermission);
			const currentUpdatedAt = getUpdatedAt(currentPermission);
			if (nextUpdatedAt !== currentUpdatedAt) {
				return nextUpdatedAt > currentUpdatedAt;
			}
			const nextId = Number(nextPermission && nextPermission.id ? nextPermission.id : 0);
			const currentId = Number(currentPermission && currentPermission.id ? currentPermission.id : 0);
			return nextId > currentId;
		};

		const upsertPermission = (permissionItem) => {
			if (!permissionItem || !permissionItem.name) return;
			const permissionName = String(permissionItem.name).toLowerCase();
			const current = this.permission[permissionName];
			const candidate = { ...permissionItem, name: permissionName };
			if (shouldReplacePermission(candidate, current)) {
				this.permission[permissionName] = candidate;
			}
		};

		if (this.list_permissions_user && this.list_permissions_user.length > 0) {
			let diff = this.diff_permissions(this.list_permissions_user, this.list_resources);
			// console.log("check permissions render ", diff, this.list_permissions_user, this.list_resources)

			this.permission = {};
			if (diff && diff.length > 0) { //  if exist diff
				diff = this.format_permissions(diff);

				diff.forEach((per)=>{ upsertPermission(per); });
				EventBus.$emit("create_format_permission_user", diff);
			}
			this.list_permissions_user.forEach((per)=>{
				upsertPermission(per);
			});
			// console.log("load permissions", this.permission);
		}else{
			// console.log("Not content permissions the users, passed like defaults")
			if (this.list_default_permissions && this.list_default_permissions.length > 0) {
				this.list_default_permissions.forEach((per)=>{
					upsertPermission(per);
				});	
			}

		}
	}

	diff_permissions(permissions, resources){
		if (resources && resources.length > 0) {
			let temp_list = [];
			if (this.list_default_resources &&  this.list_default_resources.length > 0) {
				temp_list = this.list_default_resources.filter((per) => {
            
		            if (per && per.name && per.type == "module") {
		              let idx = permissions.findIndex(x => (x &&  x.name && per.name && x.name.toLowerCase().includes(per.name.toLowerCase())))
		            
		              if (idx < 0) {
		                return true;
		              }
		            }
          		})	
			}
			// console.log("DIFF ", temp_list)
			if (temp_list && temp_list.length > 0 && this.list_default_resources.length != resources.length) {
				resources = resources.concat(temp_list);
				console.warn("has added new items to resources", temp_list);
			}
			return resources.filter((per) => {
            
	            if (per && per.name) {
	              let idx = permissions.findIndex(x => (x &&  x.name && per.name && x.name.toLowerCase().includes(per.name.toLowerCase())))
	            
	              if (idx < 0) {
	                return true;
	              }
	            }
          })
		}else{
			if (this.list_default_resources &&  this.list_default_resources.length > 0) {
				return this.list_default_resources.filter((per) => {
            
		            if (per && per.name && per.type == "module") {
		              let idx = permissions.findIndex(x => (x && x.name && per.name && x.name.toLowerCase().includes(per.name.toLowerCase())))
		            
		              if (idx < 0) {
		                return true;
		              }
		            }
          		})	
			}
		}
	}

	format_permissions(list){
		if (list && list.length > 0)  {
			let roleId 		= this.user &&  this.user.user && this.user.user.roleId ? this.user.user.roleId : null ;
			let new_list 	= [];
			list.forEach((item)=>{
				let name1 = "";
				if (item && item.name) {
					name1 = item.name.toLowerCase();  
				}else if (item.module) {
					name1 = item.module.toLowerCase(); 
				}
				new_list.push({
                  	name        : name1,
                  	roleId 	  	: roleId,
                  	resourceId  : item.id,
                  	can_add     : false,
                  	can_view    : true, 
                  	can_edit    : true,
                  	can_delete  : false,
                  	type 		: item.type_component || "route",
                })
			});
			return [ ...new_list ];
		}else{
			return [ ...list ];
		}
	}
	

	
	
}

export default user_class;
